import React from 'react'

export function Pixels() {
    return (
        <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_di_1709_33442)">
                <g clip-path="url(#clip0_1709_33442)">
                    <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_1709_33442)"/>
                    <g filter="url(#filter1_dd_1709_33442)">
                        <path d="M33 27V11.5C33 10.122 31.878 9 30.5 9H11.5C10.122 9 9 10.122 9 11.5V27H20V29H15V31H27V29H22V27H33ZM21.846 21.568L18.846 18.568L14.572 22.842L13.158 21.428L18.846 15.74L21.846 18.74L25.586 15H23.023V13H27.501C28.328 13 29.001 13.673 29.001 14.5V18.978H27.001V16.415L21.847 21.569L21.846 21.568Z" fill="url(#paint1_linear_1709_33442)"/>
                    </g>
                </g>
            </g>
            <defs>
                <filter id="filter0_di_1709_33442" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="0.5"/>
                    <feGaussianBlur stdDeviation="0.25"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1709_33442"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1709_33442" result="shape"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="0.5"/>
                    <feGaussianBlur stdDeviation="0.25"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
                    <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1709_33442"/>
                </filter>
                <filter id="filter1_dd_1709_33442" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="10"/>
                    <feGaussianBlur stdDeviation="10"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1709_33442"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="3.89851"/>
                    <feGaussianBlur stdDeviation="15"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"/>
                    <feBlend mode="normal" in2="effect1_dropShadow_1709_33442" result="effect2_dropShadow_1709_33442"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1709_33442" result="shape"/>
                </filter>
                <linearGradient id="paint0_linear_1709_33442" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#29282C"/>
                    <stop offset="1" stop-color="#100F11"/>
                </linearGradient>
                <linearGradient id="paint1_linear_1709_33442" x1="8.81456" y1="4.47972" x2="24.2365" y2="29.1394" gradientUnits="userSpaceOnUse">
                    <stop stop-color="white"/>
                    <stop offset="1" stop-color="white" stop-opacity="0.65"/>
                </linearGradient>
                <clipPath id="clip0_1709_33442">
                    <rect x="1" width="40" height="40" rx="12" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    )
}